import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("ap-cart")) || [];
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);
  const [promo, setPromoState] = useState(() => localStorage.getItem("ap-promo") || "");

  const setPromo = (code) => {
    setPromoState(code);
    if (code) localStorage.setItem("ap-promo", code);
    else localStorage.removeItem("ap-promo");
  };

  useEffect(() => {
    localStorage.setItem("ap-cart", JSON.stringify(items));
  }, [items]);

  const variantPrice = (product, caps) => {
    const v = (product.variants || []).find((x) => x.caps === caps);
    return v ? v.price : product.price;
  };

  const addItem = (product, qty = 1, variant = null) => {
    const v = variant ?? ((product.variants || []).some((x) => x.caps === 60) ? 60 : (product.variants || [])[0]?.caps ?? 60);
    const key = `${product.slug}:${v}`;
    const price = variantPrice(product, v);
    setItems((prev) => {
      const idx = prev.findIndex((i) => i.key === key);
      if (idx >= 0) {
        const next = [...prev];
        next[idx] = { ...next[idx], qty: Math.min(next[idx].qty + qty, 20) };
        return next;
      }
      return [
        ...prev,
        { key, slug: product.slug, variant: v, name: product.i18n?.en?.name || product.slug, price, image: product.image, qty, cs: Boolean(product.coming_soon), unit: product.unit || "caps" },
      ];
    });
    setOpen(true);
  };

  const updateQty = (key, qty) => {
    if (qty < 1) return;
    setItems((prev) => prev.map((i) => (i.key === key ? { ...i, qty: Math.min(qty, 20) } : i)));
  };

  const removeItem = (key) => setItems((prev) => prev.filter((i) => i.key !== key));
  const clear = () => setItems([]);

  const { count, subtotal } = useMemo(() => {
    const count = items.reduce((s, i) => s + i.qty, 0);
    const subtotal = items.reduce((s, i) => s + i.qty * i.price, 0);
    return { count, subtotal };
  }, [items]);

  const shipping = subtotal === 0 ? 0 : 6.9;

  return (
    <CartContext.Provider value={{ items, addItem, updateQty, removeItem, clear, count, subtotal, shipping, open, setOpen, variantPrice, promo, setPromo }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
